/**
 * @generated SignedSource<<55927a73e6eb9384d452157274237337>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StreamAutoRecordAutomationConfig_viewer$data = {
  readonly hasAccessToCopilot: boolean;
  readonly remainingMeetingRecordingCredits: number;
  readonly " $fragmentSpreads": FragmentRefs<"StreamAutoRecordAutomationConfig_useAutoRecordReason_viewer">;
  readonly " $fragmentType": "StreamAutoRecordAutomationConfig_viewer";
};
export type StreamAutoRecordAutomationConfig_viewer$key = {
  readonly " $data"?: StreamAutoRecordAutomationConfig_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"StreamAutoRecordAutomationConfig_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StreamAutoRecordAutomationConfig_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remainingMeetingRecordingCredits",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAccessToCopilot",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StreamAutoRecordAutomationConfig_useAutoRecordReason_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "7c6f3e22c3eb21b031347aaaad2fe40b";

export default node;
